import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import _ from 'lodash'
import Wording from '@/utils/words'
import Master from '@/utils/master'
import { encryptPayload } from '@/utils/crypto'

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  if(error.response.status == 500) window.location.reload()
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)))
  failedQueue = []
}

// ---------------- API REST ----------------------------
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  timeout: 60000,
  headers: {
    'SOURCE' : import.meta.env.VITE_APP_SOURCE,
    'X-Frame-Options': 'deny',
    'Content-Type': 'application/json',
    'X-XSS-Protection': '1; mode=block',
    'X-Content-Type-Option': 'nosniff',
    'Content-Security-Policy': "script-src 'self'",
    'Strict-Transport-Security': 'max-age=31536000;includeSubDomains',
  },
})
// Request interceptor
api.interceptors.request.use((config) => {
  const auth = useAuthStore()

  if (auth.BoUserToken) {
    config.headers['Authorization'] = `Bearer ${auth.BoUserToken}`
    config.headers['X-CODE-CHALLENGE'] = auth.BoUserToken
    config.headers['X-SESS-ROLE'] = auth.RSession?.code
    config.headers['X-CSRF-TOKEN'] = document.querySelector("meta[name='csrf-token']").content
    config.headers['X-SESS-PAGE-COOKIE'] = document.querySelector(
      "meta[name='sess-cookie']",
    ).content
    config.headers['X-SESS-PAGE-ID'] = window.sessPageID

    config.headers['X-Request-ID'] = 'req-id'
    config.headers['X-CSRF-NAME'] = 'csrfName'
    config.headers['X-Encrypted'] = '1'
  }
  return config
})
// Response interceptor (refresh-token)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const auth = useAuthStore()
    const originalRequest = error.config

    const method = originalRequest?.method?.toUpperCase() || 'UNKNOWN'

    if (method === 'POST' && error.response?.data.csrfToken) {
      document
        .querySelector('meta[name="csrf-token"]')
        .setAttribute('content', error.response?.data.csrfToken)
    }

    if (error.response?.data?.code == 'ROUTE_DENIED') {
      window.location.href = import.meta.env.VITE_BASE_URL + '/panel'
    }

    if (error.response?.status == 419) {
      window.location.reload()
    }

    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error)
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject })
      })
        .then(() => {
          return api(originalRequest)
        })
        .catch((err) => Promise.reject(err))
    }

    originalRequest._retry = true
    isRefreshing = true

    try {
      const { data } = await api.post('/auth/refresh', {
        payload: {
          token: auth.RefreshToken,
        },
      })

      auth.updateUserToken(data.codeChallenge)
      auth.updateRefreshToken(data.refreshToken)

      processQueue(null, data.codeChallenge)
      return api(originalRequest)
    } catch (err) {
      processQueue(err, null)
      auth.logoutUserToken()
      return Promise.reject(err)
    } finally {
      isRefreshing = false
    }
  },
)
// ---------------- API REST ----------------------------


// ---------------- API UPLOAD ----------------------------
const apiUpload = axios.create({
  baseURL: import.meta.env.VITE_UPLOAD_URL,
  withCredentials: true,
  timeout: 60000,
  headers: {
    'SOURCE' : import.meta.env.VITE_APP_SOURCE,
    'X-Frame-Options': 'deny',
    'Content-Type': 'application/json',
    'X-XSS-Protection': '1; mode=block',
    'X-Content-Type-Option': 'nosniff',
    'Content-Security-Policy': "script-src 'self'",
    'Strict-Transport-Security': 'max-age=31536000;includeSubDomains',
  },
})
// Request interceptor
apiUpload.interceptors.request.use((config) => {
  const auth = useAuthStore()

  if (auth.BoUserToken) {
    config.headers['Authorization'] = `Bearer ${auth.BoUserToken}`
    config.headers['X-CODE-CHALLENGE'] = auth.BoUserToken
    config.headers['X-SESS-ROLE'] = auth.RSession?.code
    config.headers['X-CSRF-TOKEN'] = document.querySelector("meta[name='csrf-token']").content
    config.headers['X-SESS-PAGE-COOKIE'] = document.querySelector(
      "meta[name='sess-cookie']",
    ).content
    config.headers['X-SESS-PAGE-ID'] = window.sessPageID
    config.headers['X-Request-ID'] = 'req-id'
    config.headers['X-CSRF-NAME'] = 'csrfName'
    config.headers['X-Encrypted'] = '1'
  }
  return config
})
// Response interceptor (refresh-token)
apiUpload.interceptors.response.use(
  (response) => response,
  async (error) => {
    const auth = useAuthStore()
    const originalRequest = error.config

    const method = originalRequest?.method?.toUpperCase() || 'UNKNOWN'

    if (method === 'POST' && error.response?.data.csrfToken) {
      document
        .querySelector('meta[name="csrf-token"]')
        .setAttribute('content', error.response?.data.csrfToken)
    }

    if (error.response?.data?.code == 'ROUTE_DENIED') {
      window.location.href = import.meta.env.VITE_BASE_URL + '/panel'
    }

    if (error.response?.status == 419) {
      window.location.reload()
    }

    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error)
    }

    // if (isRefreshing) {
    //   return new Promise((resolve, reject) => {
    //     failedQueue.push({ resolve, reject })
    //   })
    //     .then(() => {
    //       return api(originalRequest)
    //     })
    //     .catch((err) => Promise.reject(err))
    // }

    // originalRequest._retry = true
    // isRefreshing = true

    // try {
    //   const { data } = await api.post('/auth/refresh', {
    //     payload: {
    //       token: auth.RefreshToken,
    //     },
    //   })

    //   auth.updateUserToken(data.codeChallenge)
    //   auth.updateRefreshToken(data.refreshToken)

    //   processQueue(null, data.codeChallenge)
    //   return api(originalRequest)
    // } catch (err) {
    //   processQueue(err, null)
    //   auth.logoutUserToken()
    //   return Promise.reject(err)
    // } finally {
    //   isRefreshing = false
    // }
  },
)
// ---------------- API UPLOAD ----------------------------


// Helper axiosService
const axiosService = {
  apiHeader() {
    return {
      'X-CSRF-TOKEN': document.querySelector("meta[name='csrf-token']").content,
    }
  },
  async apiRest(path, config = {}) {
    if(path == 'dashboard'){
      return
    }

    const options = {
      method: (config.method || 'GET').toUpperCase(),
      url: path,
      data: config.data ? { payload : await encryptPayload(config.data || {}, { keyId: 'v1' }) } : undefined,
      params: config.params,
      timeout: config.timeout,
      responseType: path.includes('export_list') || config.download ? 'blob' : undefined,
      headers: { ...axiosService.apiHeader(), ...(config.headers || {}) },
    }

    return api(options)
  },
  uploadRest(path, formData) {
    return apiUpload.post(path, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}

export { api, axiosService, Wording, Master }
